// extracted by mini-css-extract-plugin
export default {"progress":"SignUpProgress_progress__4bmcm"};